import React, { useState, ReactNode } from "react";
import { ReactComponent as EmailImg } from "../../../assets/illustrations/email-240x240.svg";
import { Modal, Button, Icon } from "../../../components/common";
import { NavLink } from "react-router-dom";
import { SUPPORT_EMAIL } from "../../../constants";

type Props = {
  children: (fn: () => void) => ReactNode;
  title: string;
  subtitle: string;
};

export const ContactSupportModal: React.FC<Props> = (props) => {
  const [isOpen, setIsOpen] = useState(false);

  const { children, title, subtitle } = props;

  const actionHandler = () => setIsOpen(true);

  return (
    <>
      <>{children(actionHandler)}</>

      <Modal
        isOpen={isOpen}
        close={() => setIsOpen(false)}
        title={title}
        subtitle={subtitle}
      >
        <div className="flex flex-row items-center justify-center mb-12">
          <EmailImg />
        </div>
        <div className="flex flex-col text-center mb-12">
          <span>Click the button to send a ticket to</span>
          <NavLink to={`mailto:${SUPPORT_EMAIL}`} className="text-blue-500">
            support@archway.finance
          </NavLink>
        </div>
        <Button
          variant={Button.variant.PRIMARY}
          className="w-full"
          contentClassName="w-full"
          component={NavLink}
          to={`mailto:${SUPPORT_EMAIL}`}
        >
          <span className="flex flex-row justify-between w-full">
            Send request{" "}
            <Icon icon="Mail" size={24} className="text-white" disableFill />
          </span>
        </Button>
      </Modal>
    </>
  );
};
